<ul class="layout-menu">
  @for (item of model$ | async; track item.id; let i = $index) {
    @if (item.separator) {
      <li class="menu-separator"></li>
    } @else {
      <li app-menuitem [item]="item" [index]="i" [root]="true"></li>
    }
  }
</ul>
